import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import styled from 'styled-components';
import courseInProgress from '../../img/course-in-progress.svg';
import { cancelCourse } from './courseActions';

const CustomPaper = styled(Paper)`
  padding: 0px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-color: red;
`;

const Wording = styled.span`
  font-size: 1.3em;
  font-weight: bold;
  margin-left: 30px;
`;

const CustomButton = styled(Button)`
  margin-left: auto;
  text-transform: none;
`;
/**
 * [CoursePaper description]
 * @param {Function} dispatchCancelCourse Annuler une course avec son id
 * @param {Object} currentCourse          Course en cours
 */
const CoursePaper = ({ dispatchCancelCourse, currentCourse }) => (
  <CustomPaper>
    <img src={courseInProgress} alt="course in progress" />
    <Wording>Vous avez une course en cours</Wording>
    <CustomButton
      onClick={() => dispatchCancelCourse(currentCourse.id)}
      variant="contained"
      color="secondary"
      style={{}}
    >
      Annuler la course
    </CustomButton>
  </CustomPaper>
);

const mapStateToProps = state => ({
  currentCourse: state.init.currentCourse
});

const mapDispatchToProps = dispatch => ({
  dispatchCancelCourse: courseId => dispatch(cancelCourse(courseId))
});

CoursePaper.propTypes = {
  dispatchCancelCourse: PropTypes.func.isRequired,
  currentCourse: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(CoursePaper);
